const actions = {};
actions.ADD_CONSIGNOR_LIST = 'ADD_CONSIGNOR_LIST';
actions.ADD_CONSIGNOR_GROUP = 'ADD_CONSIGNOR_GROUP';
actions.SET_CONSIGNOR = 'SET_CONSIGNOR';

export { actions };
